import { concatURI, sleep, concatWithDashLine } from '@/utils/common'
import { concatWithSymbol } from '@custouch/proxy-use'
export default {
    methods: {
        sendToMail(item) {
            let { fullPath } = this.$route
            const pdfRelativedKeys = []
            let resourceId, filename
            if (Array.isArray(item)) {
                resourceId = item
                    .map(item => this.getResourceId(item.pdfLink))
                    .join(',')
                filename = item.map(item => this.getFilename(item)).join('；')
            } else {
                resourceId = this.getResourceId(item.pdfLink)
            }
            if (resourceId) {
                pdfRelativedKeys.push({
                    key: 'c_resourceIds',
                    val: resourceId
                })
            } else {
                pdfRelativedKeys.push({
                    key: 'c_fileurl',
                    val: item.pdfLink
                })
            }
            const link = concatURI(window.env.VUE_APP_DOWNLOAD_PDF_FORM, [
                ...pdfRelativedKeys,
                {
                    key: 'c_filename',
                    val: filename || this.getFilename(item)
                },
                {
                    key: 'redirect',
                    val: fullPath
                },
                {
                    key: 'msg',
                    val: '文件发送成功，请至邮箱查收'
                }
            ])
            window.location.href = link
        },
        getFilename(item) {
            return concatWithSymbol([item.name || item.productName, item.pdfName])
        },
        getResourceId(url) {
            if (/^https:\/\/download\.(cloud|beta)\.custouch\.com/.test(url)) {
                let s = url.split('/')
                return s[s.length - 1]
            }
            return null
        },
        async download(item) {
            if (item.pdfLink) {
                let link = this.getPdfUrl(item.pdfLink)
                const name =
                    concatWithDashLine(item.productName, item.pdfName) ||
                    item.name
                this.$root.$emit('actionview', {
                    info: {
                        name,
                        source: link
                    },
                    actionType: 'downloadview'
                })
                await sleep(50)
                window.location.href = link
            }
        },
        getPdfUrl(link) {
            if (!link) return
            let list = link.split('/')
            let name = list[list.length - 1].split('?')[0]
            return link.replace(name, encodeURIComponent(name))
        }
    }
}
